import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayBackBtnComponent } from './play-back-btn.component';
import { SharedModule } from '../../../shared.module';
import { ImagesModule } from '../../images/images.module';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { MyHammerConfig } from '../../../hammer/hammer.module';



@NgModule({
  declarations: [
    PlayBackBtnComponent
  ],
  exports: [
    PlayBackBtnComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ImagesModule
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    }
  ],
})

export class PlaybackModule { }
